import {connect} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {getHomeInternalUrl} from "../constants/appRoutes";
import Call from "../hocs/call";
import {submitUserEmailConfirmation} from "../state/user/userActions";

const mapDispatchToProps = dispatch => ({
  onMailValidationSubmit: ({username, token}) => dispatch(submitUserEmailConfirmation(username, token))
});

const ConfirmEmailDomain = ({onMailValidationSubmit, children}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const usernameParam = atob(new URLSearchParams(location.search).get("username"));
  const tokenParam = new URLSearchParams(location.search).get("token");

  if (!usernameParam || !tokenParam) {
    navigate(getHomeInternalUrl());
  }

  return (
    <Call
      cb={onMailValidationSubmit}
      cbParam={{
        username: usernameParam,
        token: tokenParam
      }}
      disabled={!usernameParam || !tokenParam}
    >
      {children}
    </Call>
  );
};

export default connect(null, mapDispatchToProps)(ConfirmEmailDomain);
